// Scheduled publishing for blog posts.
//
// A post goes live on its `date` (posts.json). Until then it is left out of
// the blog index, its own URL, the sitemap, the feeds and the prerender. "Today"
// is the India date (Asia/Kolkata), so a post dated November 1 appears from
// midnight IST on November 1.
//
// The day is fixed at BUILD time, not in the visitor's browser: the prerendered
// HTML and the hydrating client must agree on which posts exist, or React
// hydration breaks. So a scheduled post only appears after a build on or after
// its date. .github/workflows/scheduled-publish.yml (on main) redeploys every
// night at 00:05 IST for exactly that.
//
// A hard refresh of an existing article reuses its slug with a new entry and a
// later date. Until that date the old entry stays live; from that date the
// newest live entry for the slug wins.
//
// Plain JS on purpose: imported by the app (Vite) and by the Node build scripts.

export const PUBLISH_TZ = 'Asia/Kolkata';

// 'October 29, 2026' -> '2026-10-29'
export function isoDay(humanDate) {
  const d = new Date(`${humanDate} 12:00:00 UTC`);
  if (Number.isNaN(d.getTime())) throw new Error(`unparseable post date: ${humanDate}`);
  return d.toISOString().slice(0, 10);
}

// Today in India as 'YYYY-MM-DD'.
export function publishDay(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: PUBLISH_TZ, year: 'numeric', month: '2-digit', day: '2-digit'
  }).format(now);
}

// Posts live on `day`, newest entry per slug, original order kept.
export function livePosts(posts, day, { showScheduled = false } = {}) {
  const visible = showScheduled ? posts : posts.filter((p) => isoDay(p.date) <= day);
  const newest = new Map();
  for (const p of visible) {
    const cur = newest.get(p.slug);
    if (!cur || isoDay(p.date) > isoDay(cur.date)) newest.set(p.slug, p);
  }
  return visible.filter((p) => newest.get(p.slug) === p);
}
